import { BasicEvent } from "@h4x/common";


export class Router {
	public static readonly pathURL: string;
	public static readonly page: string;
	public static readonly parts: string[];
	public static readonly onUpdate = new BasicEvent<() => void>();

	static #handler: (page: string, parts: string[]) => JSX.Element;
	public static get handler() {
		return Router.#handler(Router.page, Router.parts);
	}

	static #handlers: { [key: string]: (page: string, parts: string[]) => JSX.Element } = {};
	public static addHandler(name: string, handler: (page: string, parts: string[]) => JSX.Element) {
		Router.#handlers[name.toLowerCase()] = handler;
	}

	public static get path() {
		return Router.pathURL;
	}

	public static get(url: string) {
		url = url;

		if (url.includes("?")) {
			let parts = url.split("?");
			parts[0] = parts[0].toLowerCase();
			url = parts.join("?");
		} else {
			url = url.toLowerCase();
		}

		if (!url.startsWith("/")) {
			url = "/" + url;
		}
		return url;
	}

	public static navigate(url: string, history = true) {
		url = Router.get(url);
		if (Router.pathURL !== url) {
			Router.load(url, history);
			Router.onUpdate.execute();
			scroll(0, 0);
		}
	}

	public static load(url: string, history: boolean) {
		let { path, page, parts } = Router.parseURL(url);

		(Router as any).pathURL = path;
		(Router as any).page = page.toLowerCase();
		(Router as any).parts = parts;
		// Router.#handler = RouterPages[page] || RouterPages["error"]!;
		Router.#handler = Router.#handlers[page.toLowerCase()] || Router.#handlers["error"]!;
		if (history === true) {
			window.history.pushState({}, "", window.location.origin + Router.pathURL);
		}
	}

	public static parseURL(url: string) {
		let current = url;
		if (url.includes("?")) {
			current = url.split("?")[0];
		}

		let path = url;
		let parts = current.split("/").filter(x => x !== "");
		let page = parts.shift() || "home";
		return { path: path, page: page, parts: parts };
	}
}

window.addEventListener("popstate", () => {
	Router.navigate(window.location.pathname, false);
});
